var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{attrs:{"type":_vm.type,"disabled":_vm.disabled,"loading":_vm.resolving,"size":_vm.size,"ghost":_vm.ghost},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.open()}}},[_c('Icon',{attrs:{"type":_vm.iconType,"size":_vm.iconSize,"color":_vm.iconColor}}),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }